import styled from 'styled-components'

export const ProductCareWrapper = styled.div`
  position: relative;
  padding-top: 8px;
`
export const BadgeWrapper = styled.div`
  position: absolute;
  left: 15px;
  top: 8px;
`
